import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/** Keep delivery information aligned with Horizon's server-rendered variant state. */
class ArtajPurchaseInfo extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#update, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #update = (event) => {
    const next = event.detail?.data?.html?.getElementById(this.id);
    if (next) morph(this, next);
  };
}

if (!customElements.get('artaj-purchase-info')) {
  customElements.define('artaj-purchase-info', ArtajPurchaseInfo);
}
